import IEmptyState from "EmptyState";
import React from 'react';

interface IAudioSystemComparisonTableItemPowerBarProps {
    title: string;
    value: number;
}

export default class AudioSystemComparisonTableItemPowerBar extends React.Component<IAudioSystemComparisonTableItemPowerBarProps, IEmptyState> {
    constructor(props: IAudioSystemComparisonTableItemPowerBarProps) {
        super(props);
        this.state = {}
    }

    public render() {
        return (
            <div className="power-bar">
                <div className="title">
                    {this.props.title}
                </div>
                <div className="bars">
                    {Array.fromRange(1, this.props.value).map(v => 
                        <div key={v} className="bar"></div>
                    )}
                </div>
            </div>
        );
    }
}